import OrganisationSelector from './OrganisationSelector';
import OrganisationSelectorContainer from './OrganisationSelectorContainer';

export { OrganisationSelectorContainer };
export default OrganisationSelector;



// WEBPACK FOOTER //
// ./src/components/OrganisationSelector/index.js